export const styles = {
    root: {
        padding: 20
    },
    table: {
        height: "85vh",
        overflowX: "auto",
        overflowY: "auto"
    }
}